export default {"src":"/_next/static/media/genie_text.93cc637f.svg","height":20,"width":51,"blurWidth":0,"blurHeight":0};